<!-- Preloader Start -->
<div id="preloader-active">
    <div class="preloader d-flex align-items-center justify-content-center">
        <div class="preloader-inner position-relative">
            <div class="preloader-circle"></div>
            <div class="preloader-img pere-text">
                <img [src]="data?.Logo2Url" style="width: 80px;" alt="">
            </div>
        </div>
    </div>
</div>
<!-- Preloader Start -->

<header>
    <!-- Header Start -->
   <div class="header-area header-transparent">
        <div class="main-header ">
            <div class="header-top d-none d-lg-block">
               <div class="container-fluid">
                   <div class="col-xl-12">
                        <div class="row d-flex justify-content-between align-items-center">
                            <div class="header-info-left">
                                <ul>     
                                    <li>{{data.Fone}}</li>
                                    <li>{{data.Email}}</li>
                                    <li>{{data.Horarios}}</li>
                                </ul>
                            </div>
                            <div class="header-info-right">
                                <ul class="header-social">    
                                    <li><a href={{data.SocialLinks.WhatsApp.Url}} target="blank"><i class="fab fa-whatsapp"></i></a></li>
                                    <li><a href={{data.SocialLinks.Facebook.Url}} target="blank"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="{{data.SocialLinks.Instagram.Url}}" target="blank"><i class="fab fa-instagram"></i></a></li>
                                   <li> <a href="{{data.SocialLinks.Google.Url}}" target="blank"><i class="fab fa-google-plus-g"></i></a></li>
                                </ul>
                            </div>
                        </div>
                   </div>
               </div>
            </div>
           <div class="header-bottom  header-sticky">
                <div class="container-fluid">
                    <div class="row align-items-center">
                        <!-- Logo -->
                        <div class="col-xl-2 col-lg-2 col-md-1">
                            <div class="logo">
                                <!-- logo-1 -->
                                <a href="index.html" class="big-logo"><img [src]="data.Logo1Url" style="max-width: 140px;" alt=""></a>
                                <!-- logo-2 -->
                                <a href="index.html" class="small-logo"><img [src]="data.Logo1Url" style="width: 110px;" alt=""></a>
                            </div>
                        </div>
                        <div class="col-xl-8 col-lg-8 col-md-8">
                            <!-- Main-menu -->
                            <div class="main-menu f-right d-none d-lg-block">
                                <nav> 
                                    <ul id="navigation">                                                                                                                   
                                        <li *ngFor="let link of data.Links"><a href="{{link.Url}}">{{link.Nome}}</a></li>
                                    </ul>
                                </nav>
                            </div>
                        </div>             
                        <div class="col-xl-2 col-lg-2 col-md-3">
                            <div class="header-right-btn f-right d-none d-lg-block">
                                <a href="/#/contato" class="btn">Contate-nos</a>
                            </div>
                        </div>
                        <!-- Mobile Menu -->
                        <div class="col-12">
                            <div class="mobile_menu d-block d-lg-none"></div>
                        </div>
                    </div>
                </div>
           </div>
        </div>
   </div>
    <!-- Header End -->
</header>